<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="错题练习" goBack="true"></head-top>
		<div class="con">
			<div v-if="list.length>0">
				<div v-for="item in list" :key="item.id" class='list_item ellipsis_1' @click='toDetail(item.content.id)'>
					{{item.content.chapterName}}
				</div>
			</div>
			<div v-else class="color_e font_size_c paddinga">
				<img :src='resourceDomain+"static/icon/no_order.png"' class="noorder">
					暂无数据，逛逛别的分类吧~
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	export default {
		name: 'PracticeWrong',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				list: []
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {
		},
		activated() {
			this.updatePage()
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							this.chapterErrorList()
						},
						
			// 获取章节列表
			chapterErrorList() {
				this.$toast.loading({
					overlay: true,
					message: "加载中...",
					duration: 0,
				});
				api.get('/mp/practice/question/chapterErrorList').then(res => {
					this.$toast.clear();
					console.log(res, "---------------chapterErrorList");
					if (res.success) {
						this.list = res.data.searchHits
					} else {
						this.$toast(res.message);
					}
				})
			},

			// 跳转详情
			toDetail(id) {
				this.$router.push({
					'path': '/practice_wrong_detail',
					query: {
						id: id
					}
				})
			}

		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.con {
		padding-top: 48px
	}
	.list_item{
	  height: 40px; 
	  text-align:center;
	  line-height:40px;
	  background-color:#FFF;
	  margin:20px auto;
		padding:0 15px;
		width:315px;
		font-size:14px;
	}
	.paddinga {
		text-align: center;
		padding: 15px 0;
	}
	
	.noorder {
		width: 345px;
		height: 172.5px;
		margin: 15vh auto 25px;
		display:block;
	}
</style>
